module.exports = __webpack_public_path__ + "static/media/jammin_jars.push.ac4920c5.jpeg";